import React from "react";
import "../layout/layouts-styles.css";

/**
 * Case status — the single source of truth for what a status is called
 * and what colour it wears.
 *
 * The tone name maps to a `.status-*` class in src/theme/tokens.css, so
 * the tag, the row spine in BaseTable and the dashboard tiles all read
 * the same two custom properties and can never drift apart.
 *
 * Numeric codes come from the API (see commonFunctions.getStatus).
 */
export const STATUS_MAP = {
  0: { label: "Pending", tone: "new" },
  1: { label: "Taken", tone: "refinement" },
  2: { label: "Submitted", tone: "modification" },
  3: { label: "Rejected", tone: "rejected" },
  4: { label: "Approved", tone: "approved" },
  5: { label: "Complete", tone: "approved" },
};

export const statusLabel = (status) =>
  (STATUS_MAP[status] && STATUS_MAP[status].label) || "Unknown";

export const statusTone = (status) =>
  (STATUS_MAP[status] && STATUS_MAP[status].tone) || "neutral";

/** Class carrying --status-fg / --status-bg for a given status code. */
export const statusClass = (status) => `status-${statusTone(status)}`;

const StatusTag = ({ status, label }) => (
  <span className={ `status-tag ${statusClass(status)}` }>
    { label || statusLabel(status) }
  </span>
);

export default StatusTag;
